import { render, staticRenderFns } from "./ExaminationRoomTeacherSave.vue?vue&type=template&id=1fd7bb8e&"
import script from "./ExaminationRoomTeacherSave.vue?vue&type=script&lang=js&"
export * from "./ExaminationRoomTeacherSave.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationRoomTeacherSave.vue?vue&type=style&index=0&id=1fd7bb8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports